var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThinDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.236585 0.580983C0.156601 0.631883 0.0947946 0.715502 0.0657094 0.806394C-0.00336795 1.0209 0.0766164 1.16632 0.472904 1.51898C0.654686 1.68258 0.876457 1.89345 0.96735 1.98798C1.05824 2.0825 1.58177 2.56241 2.13076 3.04959C2.67974 3.5404 3.49049 4.2639 3.93039 4.66018C4.81385 5.45276 4.96292 5.5509 5.19196 5.48183C5.32649 5.43822 6.07542 4.79833 6.69349 4.19118C6.81346 4.07122 7.33699 3.5913 7.85689 3.1223C8.37678 2.6533 8.89306 2.18067 9.00214 2.06433C9.11121 1.95162 9.35842 1.71894 9.5511 1.54443C9.96556 1.16996 10.0492 1.02453 9.97649 0.806394C9.88921 0.540991 9.58021 0.421015 9.32206 0.555534C9.21664 0.610069 7.74781 1.92254 7.72239 1.98434C7.7151 1.99889 7.50789 2.19885 7.25703 2.42425C7.00617 2.6533 6.71896 2.92234 6.62078 3.02414C6.40628 3.23864 5.12653 4.39479 5.06471 4.43115C5.0211 4.45293 3.06875 2.71511 2.36707 2.02797C1.81082 1.48626 0.840104 0.61734 0.720125 0.555534C0.560157 0.47555 0.382011 0.482821 0.236585 0.580983Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinDownArrow);
export default __webpack_public_path__ + "static/media/thin-down-arrow.3dcccb7c949e67837944a136479f6d46.svg";
export { ForwardRef as ReactComponent };